import React, { useEffect, useState, useContext } from "react";
import { loadSpace, InitOptions } from "@usersnap/browser";

import { Stores, useGlobalState, useTranslation } from "react-migration/lib";
import { ENVIRONMENT } from "src/js/util/environment";

import { ChatSmileIcon } from "../ChatSmileIcon";

export const UserSnapButton = () => {
  const { t } = useTranslation();
  const userSnapApi = useUsersnapApi();
  const handleOpenWidgetForce = () => {
    if (ENVIRONMENT.USERSNAP_PROJECT_API_KEY)
      userSnapApi
        ?.show(ENVIRONMENT.USERSNAP_PROJECT_API_KEY)
        .then((widgetApi) => widgetApi.open({}));
  };

  return (
    <div
      data-testid="user-snap"
      onClick={handleOpenWidgetForce}
      className="atlas-text-content-inverse-secondary hover:atlas-text-white atlas-cursor-pointer atlas-items-center atlas-gap-1 atlas-hidden md:atlas-flex atlas-mx-2"
    >
      <ChatSmileIcon />
      <div className="atlas-text-sm atlas-min-w-max atlas-hidden lg:atlas-block">
        {t("nav.nav.give_us_feedback")}
      </div>
    </div>
  );
};

type UserSnapProps = {
  test: React.ReactNode;
};
export const UserSnap = ({ test }: UserSnapProps) => {
  return <>{test}</>;
};

type ApiType = Awaited<ReturnType<typeof loadSpace>>;
export const UserSnapContext = React.createContext<ApiType | null>(null);

type UserSnapProviderProps = {
  initParams: InitOptions;
  children: React.ReactNode;
};

export const UserSnapProvider = ({ initParams, children }: UserSnapProviderProps) => {
  const [userSnapApi, setUserSnapApi] = useState<ApiType | null>(null);

  useEffect(() => {
    if (ENVIRONMENT.USERSNAP_GLOBAL_API_KEY) {
      loadSpace(ENVIRONMENT.USERSNAP_GLOBAL_API_KEY).then((api) => {
        api.init(initParams);
        setUserSnapApi(api);
      });
    }
  }, [initParams]);

  return <UserSnapContext.Provider value={userSnapApi}>{children}</UserSnapContext.Provider>;
};

export const useUsersnapApi = () => useContext(UserSnapContext);

export const UserSnapButtonWrapper = () => {
  const [{ user }] = useGlobalState(Stores.user);

  return (
    <UserSnapProvider
      initParams={{ user: { userId: user._id as string, email: user.email as string } }}
    >
      <UserSnapButton />
    </UserSnapProvider>
  );
};

UserSnapButtonWrapper.displayName = "UserSnapButtonWrapper";
UserSnapButton.displayName = "UserSnapButton";
UserSnap.displayName = "UserSnap";
